module.exports = __webpack_public_path__ + "img/h-page4-66.9835470b.png";